import { AlignTypes } from '@monorepo-web/components-library';
import { helperFormat, FormatTypes, limitToModulus } from '@monorepo-web/utils';
export function formatRowsInfos1(infos_add, obj_datas, moneyPrefix) {
    if (!infos_add || Object.keys(infos_add).length === 0)
        return null;
    const rowsInfos1 = infos_add.retorno.slice(1).map((row) => {
        let i = 0;
        return {
            info: row[i++],
            carteira: helperFormat(row[i++], FormatTypes.decimals, 2),
            bench: helperFormat(row[i++], FormatTypes.decimals, 2),
        };
    });
    if (rowsInfos1 !== null && rowsInfos1.length > 0) {
        rowsInfos1.push({
            info: `PL em ${obj_datas.data_fim}`,
            carteira: '',
            bench: helperFormat(infos_add.pl_data_fim, FormatTypes.monetary, 2, moneyPrefix),
        });
        rowsInfos1.push({
            info: 'PL médio no período',
            carteira: '',
            bench: helperFormat(infos_add.pl_medio, FormatTypes.monetary, 2, moneyPrefix),
        });
    }
    return rowsInfos1;
}
export function formatRowsInfos2(infos_add) {
    const rowsInfos2 = infos_add && infos_add.comparativo
        ? infos_add.comparativo.slice(1).map((row) => {
            let i = 0;
            return {
                info: row[i++],
                valor: row[i++],
                percent: helperFormat(row[i++], FormatTypes.percentage, 2),
            };
        })
        : null;
    return rowsInfos2;
}
export function formatRowsDefault(dados, useLimitToModulus = false) {
    const rows = dados
        ? dados.slice(1).map((row) => {
            let i = 0;
            const returnObj = {
                periodo: row[i++],
                carteira: helperFormat(row[i++], FormatTypes.decimals, 2),
            };
            row.slice(2).forEach((val, i) => {
                val = useLimitToModulus ? limitToModulus(val, 999.99) : val;
                returnObj[`bench${i}`] = helperFormat(val, FormatTypes.decimals, 2);
            });
            return returnObj;
        })
        : null;
    return rows;
}
export function getColumnsInfo1(infos_add) {
    const columnsInfos1 = [
        {
            id: 'info',
            label: '',
            align: AlignTypes.left,
        },
        {
            id: 'carteira',
            label: 'Carteira',
            align: AlignTypes.right,
        },
        {
            id: 'bench',
            label: infos_add && infos_add.retorno ? infos_add.retorno[0][2].toString() : '-',
            align: AlignTypes.right,
        },
    ];
    return columnsInfos1;
}
export function getColumnsInfo2() {
    const columnsInfos2 = [
        {
            id: 'info',
            label: '',
            align: AlignTypes.left,
        },
        {
            id: 'valor',
            label: 'Valor',
            align: AlignTypes.right,
        },
        {
            id: 'percent',
            label: '%',
            align: AlignTypes.right,
        },
    ];
    return columnsInfos2;
}
export function getColumnsDefault(retorno_carteira_bench) {
    const columnsDefault = [
        {
            id: 'periodo',
            label: 'Período',
            freeze: true,
            align: AlignTypes.left,
            cellWidth: '325px',
        },
        {
            id: 'carteira',
            label: 'Carteira',
            align: AlignTypes.right,
            cellWidth: '275px',
        },
    ];
    if (retorno_carteira_bench && retorno_carteira_bench[0]) {
        retorno_carteira_bench[0].slice(2).forEach((val, i) => {
            columnsDefault.push({
                id: `bench${i}`,
                label: val.toString(),
                align: AlignTypes.right,
                cellWidth: '200px',
            });
        });
    }
    return columnsDefault;
}
